export enum TextCaseType {
    Upper,
    Lower,
    Title,
    Camel,
    Pascal
}